var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"auto"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"bdIframe","src":_vm.src,"width":"100%","height":"100%","frameborder":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }